<template>
  <div>
    <SummaryHeaderRow
      :data="data.header"
      :file-error-data="errorModel"
      @show-alert-tab="handleShowAlert"
    />
    <div v-if="errorModel.showAlert && errorModel.validations.length > 0">
      <file-error
        :errors="errorModel.validations"
        @close="errorModel.showAlert = false"
      />
    </div>
    <ResultRow
      v-for="(row, index) of data.details.data"
      :key="`result-${index}`"
      class="mb-3"
      :data="row"
      :on-refresh="onRefresh"
      :set-error-model="setErrorModel"
    />
    <pagination
      v-if="pagination.totalItemCount > pagination.pageSize"
      :data="pagination"
      show-text
      @pagination-go-page="$emit('go-to-page-handler', page)"
    />
  </div>
</template>

<script>
import SummaryHeaderRow from './SummaryHeaderRow.vue';
import ResultRow from './ResultRow.vue';
import Pagination from 'pagination';
import FileError from '@/components/common/FileError.vue';

export default {
  name: 'CertificationResult',
  components: {
    SummaryHeaderRow,
    ResultRow,
    Pagination,
    FileError,
  },
  data() {
    return {
      errorModel: {
        validations: [],
        showAlert: false,
        failedUploadsCount: 0,
      },
    };
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    pagination: {
      type: Object,
      default: () => {},
    },
    fileErrorData: {
      type: Object,
      default: () => {},
    },
    onRefresh: {
      type: Function,
    },
  },
  methods: {
    handleShowAlert(value) {
      this.errorModel.showAlert = value;
    },
    setErrorModel(newModel) {
      this.errorModel = newModel;
    },
  },
  watch: {
    fileErrorData: {
      immediate: false,
      handler(val) {
        this.errorModel = val;
      },
    },
  },
};
</script>
